import Index from '@tunnel-components/@sharded/@widgets/select/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/select/index.ts